import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./style.css";

import Layout from "../../components/Layout";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { InputMask } from "@react-input/mask";

const UserDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);

	const [username, setUsername] = useState("");
	const [mail, setMail] = useState("");
	const [password, setPassword] = useState("");
	const [tcNo, setTcNo] = useState("");
	const [birthday, setBirthday] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [company, setCompany] = useState("");
	const [devices, setDevices] = useState([]);
	const [organizations, setOrganizations] = useState([]);

	const getUser = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users/${id}`);
			if (response.ok) {
				const userData = await response.json();
				setUsername(userData.username || "");
				setMail(userData.mail || "");
				setTcNo(userData.tcNo || "");
				setBirthday(userData.birthday || "");
				setPhoneNumber(userData.phoneNumber || "");
				setCompany(userData.company || "");
				setDevices(userData.devices || []);
			} else {
				alert("Kullanıcı bulunamadı");
				navigate("/user-list");
			}
		} catch (error) {
			console.error("Kullanıcı verileri getirilirken bir hata oluştu:", error);
			alert("Kullanıcı verileri yüklenirken bir hata oluştu");
		} finally {
			setLoading(false);
		}
	};

	const getOrganizations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const orgsData = await response.json();
			setOrganizations(orgsData);
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
		}
	};

	useEffect(() => {
		if (id) {
			getUser();
			getOrganizations();
		}
	}, [id]);

	const handleUpdate = async (e) => {
		e.preventDefault();

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users-update/${id}`, {
				method: "PUT",
				body: JSON.stringify({
					username,
					mail,
					password: password || undefined,
					tcNo,
					birthday,
					phoneNumber,
					company,
					devices,
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				alert("Kullanıcı Güncellendi");
				navigate("/user-list");
			} else {
				alert("Kullanıcı güncellenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Güncelleme işlemi sırasında bir hata oluştu:", error);
			alert("Kullanıcı güncellenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	if (loading) {
		return (
			<Layout>
				<div
					className="user-modal-inputs"
					style={{ textAlign: "center", padding: "50px" }}
				>
					<Spinner animation="border" variant="primary" />
				</div>
			</Layout>
		);
	}

	return (
		<Layout>
			<div className="user-modal-inputs">
				<Form.Group style={{ display: "flex", justifyContent: "flex-end" }}>
					<a href="/view-contract">Sözleşme Görüntüle</a>
				</Form.Group>
				<Form onSubmit={handleUpdate}>
					<Form.Group>
						<label className="mb-2">Kullanıcı Adı:</label>
						<Form.Control
							type="text"
							placeholder="Kullanıcı Adı Giriniz:"
							value={username}
							required
							onChange={(e) => setUsername(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Mail Adresi:</label>
						<Form.Control
							type="email"
							placeholder="Mail Adresi Giriniz:"
							value={mail}
							required
							onChange={(e) => setMail(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Parola (Değiştirmek için yeni parola giriniz):</label>
						<Form.Control
							type="password"
							placeholder="Yeni Parola Giriniz (Boş bırakırsanız değişmez)"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">TC No:</label>
						<Form.Control
							type="text"
							maxLength={11}
							minLength={11}
							value={tcNo}
							onChange={(e) => setTcNo(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label htmlFor="birthday">Doğum Tarihi:</label>
						<Form.Control
							type="date"
							id="birthday"
							value={birthday}
							onChange={(e) => setBirthday(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Telefon Numarası:</label>
						<InputMask
							mask="+90__________"
							replacement={{ _: /\d/ }}
							className="form-control"
							placeholder="Telefon No Giriniz:"
							showMask
							value={phoneNumber}
							onChange={(e) => setPhoneNumber(e.target.value)}
						/>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Kurum:</label>
						<Form.Select
							value={company}
							onChange={(e) => setCompany(e.target.value)}
						>
							<option value="">Kurum Seçiniz</option>
							{organizations?.map((org, index) => (
								<option value={org.organisationName} key={index}>
									{org.organisationName}
								</option>
							))}
						</Form.Select>
					</Form.Group>
					<Form.Group>
						<label className="mb-2">Cihazlar:</label>
						{devices.map((device, index) => (
							<div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
								<Form.Control
									type="text"
									placeholder="Cihaz ID Giriniz"
									value={device}
									onChange={(e) => {
										const newDevices = [...devices];
										newDevices[index] = e.target.value;
										setDevices(newDevices);
									}}
									style={{ flex: 1 }}
								/>
								{devices.length > 1 && (
									<Button
										variant="danger"
										size="sm"
										type="button"
										onClick={() => {
											const newDevices = devices.filter((_, i) => i !== index);
											setDevices(newDevices);
										}}
									>
										Sil
									</Button>
								)}
							</div>
						))}
						<Button
							variant="outline-secondary"
							size="sm"
							type="button"
							onClick={() => setDevices([...devices, ""])}
							style={{ marginTop: "10px" }}
						>
							+ Cihaz Ekle
						</Button>
					</Form.Group>
					<div className="button-wrapper">
						<Button
							variant="secondary"
							type="button"
							onClick={() => navigate("/user-list")}
						>
							İptal
						</Button>
						<Button variant="primary" type="submit" disabled={btnDisabled}>
							{showSpinner ? (
								<>
									<Spinner
										animation="border"
										size="sm"
										style={{ marginRight: "8px" }}
									/>
									Güncelleniyor...
								</>
							) : (
								"Güncelle"
							)}
						</Button>
					</div>
				</Form>
			</div>
		</Layout>
	);
};

export default UserDetail;
